<template>
    <div class="rpm-bill-modal">
        <!-- button -->
        <b-btn size="sm" class="btn-ghost-blue"
               @click="showModal() ">
            <shs-icon name="calculator"></shs-icon>
        </b-btn>

        <!-- modal -->
        <b-modal size="xl"
                 no-close-on-backdrop
                 :id="modal_id">

            <template v-slot:modal-header>
                <h5 class="m-2">{{ $i18n.gt('HEADING_RPM_REVIEW') }}</h5>
                <patient-id :participant="participant">
                </patient-id>
            </template>

            <template v-slot:modal-footer>
                <b-btn variant="secondary" class="btn-cancel mr-2"
                       @click="hideModal()">
                    {{ $i18n.gt('LABEL_CANCEL') }}
                </b-btn>

                <b-btn variant="primary"
                       :to="surveyNoteRoute">
                    {{ $i18n.gt('LABEL_CREATE_RPM_REVIEW') }}
                </b-btn>
            </template>

            <b-row>
                <b-col>
                    <rpm-check-list
                        :checks="checks">
                    </rpm-check-list>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-3">
                    <b-row class="text-left">
                        <b-col>
                            <b-btn class="center-block" @click="show_history = !show_history">
                                <shs-icon :name="show_history ? 'chevron-bottom' : 'chevron-right'"></shs-icon>
                            </b-btn>
                        </b-col>
                        <b-col>
                            <h5 class="m-2">{{ $i18n.gt('LABEL_RPM_REVIEW_HISTORY') }}</h5>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-collapse v-model="show_history">
                    <b-card-body
                        class="rpm-bill-modal__history">
                        <table class="table card-table table-striped">
                            <thead>
                            <tr>
                                <td>{{ $i18n.gt('LABEL_RPM_LOCKED DATE') }}</td>
                                <td>{{ $i18n.gt('LABEL_NOTES') }}</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="bills.length == 0">
                                <td colspan="2" class="text-center">{{ $i18n.gt('LABEL_NO_RPM_HISTORY') }}</td>
                            </tr>
                            <tr v-else v-for="(note,i) in bills" :key="i">
                                <td>{{ note.locked | moment('M/D/YYYY') }}</td>
                                <td style="white-space: pre-wrap">{{ note.objective }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

export default Vue.extend({
    name: "RpmBillModal",
    props: {
        provider: Object,
        onSubmit: Function,
    },
    computed: {
        participant() {
            return this.provider.participant
        },
        modal_id() {
            return `rpm_bill_${this.provider.participant_id}`
        },
        bills() {
            let notes = this.provider.participant.surveyNotes
            return _.filter(notes, (note) => {
                return note.note_type === 'RPM_REVIEW' && note.locked
            })
        },
        draftSurveyNoteId() {
            let notes = this.provider.participant.surveyNotes
            let unlockedNote = _.filter(notes, (note) => {
                return note.note_type === 'RPM_REVIEW' && !note.locked
            })
            return unlockedNote[0] ? unlockedNote[0].id : null
        },
        surveyNoteRoute() {
            if (this.draftSurveyNoteId) {
                return `/rpm/${this.provider.practice_id}/editNote/participantId/${this.provider.participant_id}/id/${this.draftSurveyNoteId}`
            } else {
                return `/rpm/${this.provider.practice_id}/createNote/participantId/${this.provider.participant_id}/type/RPM_REVIEW`
            }
        }
    },
    data() {
        return {
            text: "",
            checks: [],
            notes: [1, 2],
            show_history: false,
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modal_id)
            this.checks = this.provider.participant.unbilled_checks
        },
        hideModal() {
            this.$bvModal.hide(this.modal_id)
        },
        submit() {
            this.$bvModal.hide(this.modal_id)
        }
    },
})
</script>

<style scoped>
.rpm-bill-modal__history {
    max-height: 400px;
    overflow-y: scroll;
}
</style>
